(() => {
  const root = document.querySelector('[data-ef-scanner]');
  if (!root) return;

  const dialog = root.querySelector('.ef-scanner__dialog');
  const camera = root.querySelector('[data-ef-scanner-camera]');
  const reader = root.querySelector('#EfScannerFallback');
  const status = root.querySelector('[data-ef-scanner-status]');
  const manualForm = root.querySelector('[data-ef-scanner-manual]');
  const manualInput = root.querySelector('[data-ef-scanner-input]');
  let activeInput = null;
  let scanner = null;
  let lastFocused = null;
  let session = 0;
  let resultHandled = false;

  const setStatus = (message, isError = false) => {
    status.textContent = message;
    status.classList.toggle('is-error', isError);
  };

  const stopCamera = async () => {
    session += 1;
    const current = scanner;
    scanner = null;
    if (!current) return;
    try {
      if (current.isScanning) await current.stop();
      current.clear();
    } catch (error) {
      /* The browser may already have stopped the camera. */
    }
  };

  const submitBarcode = (rawValue) => {
    if (resultHandled) return;
    const value = String(rawValue || '').trim();
    if (!value) {
      setStatus('Enter a barcode to search.', true);
      manualInput.focus();
      return;
    }
    resultHandled = true;
    setStatus(`Barcode found: ${value}`);
    stopCamera();
    if (activeInput) {
      activeInput.value = value;
      activeInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    window.setTimeout(() => {
      window.location.assign(`/search?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(value)}`);
    }, 180);
  };

  const scanConfig = {
    fps: 24,
    qrbox: (width, height) => ({
      width: Math.floor(width * 0.88),
      height: Math.floor(height * 0.4)
    }),
    disableFlip: false,
    experimentalFeatures: { useBarCodeDetectorIfSupported: true }
  };

  const barcodeFormats = () => {
    const format = window.Html5QrcodeSupportedFormats;
    return [
      format.CODE_128,
      format.EAN_8,
      format.EAN_13,
      format.UPC_A,
      format.UPC_E
    ];
  };

  const improveCameraFocus = async () => {
    const video = reader.querySelector('video');
    const track = video?.srcObject?.getVideoTracks?.()[0];
    if (!track?.getCapabilities || !track.applyConstraints) return;
    const capabilities = track.getCapabilities();
    const advanced = {};
    if (Array.isArray(capabilities.focusMode) && capabilities.focusMode.includes('continuous')) {
      advanced.focusMode = 'continuous';
    }
    if (capabilities.zoom && capabilities.zoom.min <= 1.5 && capabilities.zoom.max >= 1.5) {
      advanced.zoom = 1.5;
    }
    if (Object.keys(advanced).length) {
      try { await track.applyConstraints({ advanced: [advanced] }); } catch (error) { /* Optional enhancement. */ }
    }
  };

  const startCamera = async (openedSession) => {
    if (!window.isSecureContext || !navigator.mediaDevices?.getUserMedia) {
      camera.hidden = true;
      setStatus('Camera scanning requires a secure mobile browser. Enter the barcode below.', true);
      return;
    }
    try {
      setStatus('Opening your camera…');
      if (!window.Html5Qrcode) throw new Error('Scanner engine unavailable');
      if (openedSession !== session || root.hidden) return;
      reader.hidden = false;
      scanner = new window.Html5Qrcode('EfScannerFallback', { formatsToSupport: barcodeFormats() }, false);
      await scanner.start({ facingMode: 'environment' }, scanConfig, submitBarcode, () => {});
      if (openedSession !== session || root.hidden) {
        await stopCamera();
        return;
      }
      await improveCameraFocus();
      setStatus('Hold the barcode steady inside the red guide.');
    } catch (error) {
      await stopCamera();
      camera.hidden = true;
      setStatus('Camera permission was blocked or no camera was found. Enter the barcode below.', true);
      manualInput.focus();
    }
  };

  const openScanner = (trigger) => {
    resultHandled = false;
    lastFocused = trigger;
    activeInput = trigger.closest('form')?.querySelector('input[type="search"]') || null;
    camera.hidden = false;
    reader.hidden = true;
    root.hidden = false;
    document.body.classList.add('ef-scanner-open');
    dialog.focus();
    session += 1;
    startCamera(session);
  };

  const closeScanner = async () => {
    await stopCamera();
    root.hidden = true;
    document.body.classList.remove('ef-scanner-open');
    if (lastFocused) lastFocused.focus();
  };

  // Delegate scanner controls so buttons added by Shopify section re-renders
  // work without requiring a full page reload.
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ef-barcode-open]');
    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      if (root.hidden) openScanner(openButton);
      return;
    }

    if (event.target.closest('[data-ef-barcode-close]')) closeScanner();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) closeScanner();
  });

  manualForm.addEventListener('submit', (event) => {
    event.preventDefault();
    submitBarcode(manualInput.value);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden && !root.hidden) closeScanner();
  });
})();
